import axios from 'axios'
import { API_ROOT_PROD } from '../../config'


export const sapApi = axios.create({
	baseURL: API_ROOT_PROD,
	timeout: 15000,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'B1S-CaseInsensitive': true,
	},
	transformResponse: (data) => data,
	withCredentials: true,
})

export default sapApi
